(function () {
  document.querySelectorAll(".page_template_clans").forEach(tabContainer => {
    // Lấy các tab và nội dung trong phạm vi container hiện tại
    const tabs = tabContainer.querySelectorAll('.js_tab');
    const tabContents = tabContainer.querySelectorAll('.tab_content .tab_element');

    tabs.forEach((tab) => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();

        const tabId = tab.getAttribute('data-bid');
        const targetContent = tabContainer.querySelector(`#${tabId}`); // Tìm nội dung trong phạm vi container

        // Kiểm tra tabId và targetContent hợp lệ
        if (!tabId || !targetContent) {
          console.warn(`Tab hoặc nội dung không hợp lệ: data-bid=${tabId}`);
          return;
        }

        // Xóa class "active" khỏi tất cả các tab và nội dung trong container hiện tại
        tabs.forEach((tab) => tab.classList.remove('tt_active'));
        tabContents.forEach((content) => content.classList.remove('ct_active'));

        // Thêm class "active" vào tab và nội dung được chọn
        tab.classList.add('tt_active');
        targetContent.classList.add('ct_active');
      });
    });
  });
})();
